import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "selection", "results", "status", "selectedList"]
  static values = { url: String, multiple: Boolean }

  connect() {
    this.selected = new Map()
  }

  disconnect() {
    clearTimeout(this.timer)
    this.request?.abort()
  }

  search() {
    if (!this.multipleValue && this.hasSelectionTarget) this.selectionTarget.value = ""
    this.searchTarget.setCustomValidity(this.multipleValue || !this.searchTarget.value.trim() ? "" : "Select a member from the search results.")
    clearTimeout(this.timer)
    this.request?.abort()
    this.resultsTarget.replaceChildren()
    this.timer = setTimeout(() => this.load(), 200)
  }

  open() {
    if (this.multipleValue || !this.hasSelectionTarget || !this.selectionTarget.value) this.load()
  }

  async load() {
    this.request?.abort()
    const request = new AbortController()
    this.request = request
    this.statusTarget.textContent = "Searching approved members…"
    this.resultsTarget.hidden = true
    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("q", this.searchTarget.value.trim())
      const response = await fetch(url, { signal: request.signal, headers: { Accept: "application/json" }, cache: "no-store" })
      if (!response.ok || response.redirected) throw new Error("Search unavailable")
      const data = await response.json()
      if (request.signal.aborted) return
      this.resultsTarget.replaceChildren()
      for (const member of data.members) {
        const button = document.createElement("button")
        button.type = "button"
        button.className = "block w-full text-left rounded-lg px-3 py-2 text-base"
        button.textContent = `${member.name} — ${member.email || "No email"}`
        button.addEventListener("click", () => {
          if (this.multipleValue) {
            if (!this.selected.has(member.id)) this.selected.set(member.id, member)
            this.renderSelected()
            this.searchTarget.value = ""
            this.searchTarget.setCustomValidity("")
            this.close()
            this.statusTarget.textContent = ""
          } else {
            this.selectionTarget.value = member.id
            this.searchTarget.value = button.textContent
            this.searchTarget.setCustomValidity("")
            this.close()
            this.statusTarget.textContent = `${member.name} selected.`
          }
          this.searchTarget.focus()
        })
        this.resultsTarget.append(button)
      }
      this.resultsTarget.hidden = data.members.length === 0
      this.statusTarget.textContent = data.members.length === 0
        ? "No approved members found. Try another name or email."
        : data.has_more ? "Showing the first 20 matches. Refine your search to find another member." : "Choose a member from the results."
    } catch (error) {
      if (error.name !== "AbortError") this.statusTarget.textContent = "Could not load approved members. Focus the search field to retry."
    }
  }

  renderSelected() {
    if (!this.hasSelectedListTarget) return
    this.selectedListTarget.replaceChildren()
    for (const [id, member] of this.selected) {
      const row = document.createElement("div")
      row.className = "reference-selected-admin"
      const label = document.createElement("span")
      label.textContent = `${member.name} — ${member.email || "No email"}`
      const remove = document.createElement("button")
      remove.type = "button"
      remove.className = "reference-selected-admin__remove"
      remove.textContent = "Remove"
      remove.addEventListener("click", () => { this.selected.delete(id); this.renderSelected(); this.searchTarget.focus() })
      const hidden = document.createElement("input")
      hidden.type = "hidden"
      hidden.name = "administrator_ids[]"
      hidden.value = id
      row.append(label, remove, hidden)
      this.selectedListTarget.append(row)
    }
  }

  close() {
    clearTimeout(this.timer)
    this.request?.abort()
    this.resultsTarget.hidden = true
  }

  outside(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
